import type { ReactNode } from "react";

/**
 * A row of mutually exclusive choices that all fit on screen: a filter, a
 * theme. Buttons with `aria-pressed` rather than radio inputs,
 * the same as the chips they replace, so a screen reader hears "pressed".
 */
export function Segmented<T extends string>({
  label,
  value,
  options,
  onChange,
  size = "md",
  disabled = false,
}: {
  label: string;
  value: T;
  options: { value: T; label: ReactNode; title?: string }[];
  onChange: (value: T) => void;
  size?: "sm" | "md";
  disabled?: boolean;
}) {
  return (
    <div className={size === "sm" ? "segmented segmented-sm" : "segmented"} role="group" aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className="segment"
          aria-pressed={option.value === value}
          title={option.title}
          aria-label={typeof option.label === "string" ? undefined : option.title}
          disabled={disabled}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
